/* eslint-disable no-underscore-dangle */
import { debounce } from 'lodash';

/** Object to store debounced handlers for each table */
const debouncedHandlers = {};

/**
 * Get a debounced handler for a specific table or item based on its identifier.
 *
 * @param {string} identifier - The identifier
   (e.g., assignedId, table name, etc.) for the specific handler.
 * @param {function} callback - The callback function to debounce.
 * @returns {function} - The debounced function for the given identifier.
 */
export const getDebouncedHandlerForTable = (identifier, callback) => {
  /** If no debounced handler exists for this identifier, create it */
  if (!debouncedHandlers[identifier]) {
    debouncedHandlers[identifier] = debounce((...args) => {
      debouncedHandlers[identifier]._latestCallback?.(...args);
    }, 4000); /** 4-second debounce */
  }

  /** Always update to the latest callback on component re-renders */
  debouncedHandlers[identifier]._latestCallback = callback;

  /** Return the debounced handler for this specific identifier */
  return debouncedHandlers[identifier];
};

/**
 * Flush the debounced function for a specific identifier.
 */
export const flushDebounceForTable = (identifier) => {
  const handler = debouncedHandlers[identifier];
  if (handler?.flush) {
    handler.flush();
  }
};
